import api from "api/api";
import { SCOPES } from "constants/constants";

export const getFileByIdQuery = async ({ id, isBase64Request }) =>
  await api.get(`/file/${id}${isBase64Request ? "?filetype=base64" : ""}`);

// `POST /file` is a bare Rocket `TempFile` data guard: it writes the unprocessed
// request body to storage and does not parse forms. The bytes therefore go up as
// they are — hand it a multipart body and the envelope is what gets stored.
// `createFileQuery` already posts raw when its argument carries no `file`, which
// is how `uploadFileHelper` sends every picture of the app; this names that
// contract so a tidy-up of the branch below cannot silently break it.
export const createRawFileQuery = async (buffer) =>
  await api.post("/file", buffer);

export const createFileQuery = async (data) => {
  const formData = new FormData();
  formData.append("file", data.file);
  formData.append("module", data.module);
  formData.append("alt", data.alt);
  formData.append("file_name", data.fileName);
  return await api.post("/file", data.file ? formData : data);
};

export const uploadProfilePictureQuery = async ({
  userId,
  file,
  scope = SCOPES.ADMIN,
}) => {
  const formData = new FormData();
  formData.append("file", file);
  return await api.post(
    `/directory/user/${userId}/profile-picture?scope=${scope}`,
    formData
  );
};

export const deleteFileQuery = async ({ user_id, userScope }) =>
  await api.delete(
    `/directory/user/${user_id}/profile-picture?scope=${userScope}`
  );
